<div class="pos-f-t fixed-top header">
    <nav class="navbar navbar-light navbar-toggleable-md">
                
        <div class="navbar-brand">
            <img src="assets/images/smart_tracing_eslogan.svg" class="logo" />    
        </div>
                
    </nav>
</div>
